import React from 'react'
import PropTypes from 'prop-types'

// Label above a list or grid inside a step ("Enrolled golfers (12)").

const SectionHeader = ({ children }) => <div className="gl-sec-hd">{children}</div>

SectionHeader.propTypes = {
  children: PropTypes.node,
}

export default SectionHeader
